import React from "react";
import MerchantRedemptionTable from "./MerchantRedemptionTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const MerchantRedemptionIndex = () => (
  <ReportProgramsPage
    TableComponent={MerchantRedemptionTable}
    loadingMessage="Loading merchant redemption..."
  />
);

export default MerchantRedemptionIndex;
